import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private spinner = new BehaviorSubject(false);
  currentSpinnerStatus = this.spinner.asObservable();

  constructor() { }

  showSpinner(message?: string) {
    this.spinner.next(true);
  }

  hideSpinner() {
    this.spinner.next(false);
  }

  status() {
    return this.spinner.getValue();
  }

}
